"use client";

import cn from "@utils/cn";
import Link from "next/link";
import { FC } from "react";

// import "swiper/css";
// import "swiper/css/effect-fade";
// import "swiper/css/navigation";
// import "swiper/css/pagination";
import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import Image from "@/components/ui/Image/Image";
import useMediaQuery from "@/hooks/useMediaQuery";
import { EditorialCardListProps } from "@/types";

const EditorialCardList: FC<EditorialCardListProps> = ({ item }) => {
  const isDesktop = useMediaQuery("(min-width: 1024px)");
  return (
    <article className={cn(`relative group w-[311px] md:w-[343px]`)}>
      <div className="overflow-hidden rounded-lg">
        <div className="relative">
          <Image
            key={`editorial-image-${item.title}`}
            alt={item.image?.title ?? ""}
            className="aspect-4-3 transition transform hover:duration-[6000ms] group-hover:scale-105 motion-reduce:transition-none motion-reduce:hover:transform-none rounded"
            src={item.image?.url ?? ""}
            width={isDesktop ? 343 : 311}
            height={isDesktop ? 257 : 232}
          />
          <div className="absolute w-full h-full top-0 left-0 inset-0 img-overlay-5"></div>
        </div>
        <div className="absolute bottom-0 left-0 z-10 text-white p-m">
          <h3 className="font-medium uppercase font-primary text-m mb-s">{item.title}</h3>
          {item.subtitle && <p className="text-s font-secondary-light">{item.subtitle}</p>}
          {item.text && <p className="text-s font-secondary-light">{item.text}</p>}
          {item.cta?.label && (
            <Button
              href={item.cta.link.url}
              size={ButtonSize.SMALL}
              variant={ButtonVariant.PRIMARY}
              theme={ButtonTheme.WHITE}
              customClass={"flex justify-center md:px-l mt-m md:py-xs !border-white hover:!border-0 w-fit"}
            >
              {item.cta.label}
            </Button>
          )}
        </div>
        {item.cta && (
          <Link href={item.cta.link.url} className="absolute top-0 left-0 z-10 w-full h-full">
            <span className="sr-only">{item.cta.label}</span>
          </Link>
        )}
      </div>
    </article>
  );
};

export default EditorialCardList;
